<template>
  <v-dialog v-model="dialog" persistent max-width="750">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-on="on" v-bind="attrs"
        ><v-icon>mdi-cart-arrow-right</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">Retiradas</v-card-title>
      <v-card-subtitle>{{ produto.descproduto }}</v-card-subtitle>
      <v-card-text>
        <v-data-table
          :items="produto.retiradas"
          :headers="headers"
          no-data-text="Nenhuma informação encontrada"
        ></v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" text>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    produto: { type: Object, required: true },
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Filial", value: "filial" },
      { text: "Cfop", value: "cfop" },
      { text: "Nota", value: "nota" },
      { text: "Emissão", value: "emissao" },
      { text: "Qtde", value: "qtde" },
    ],
  }),
};
</script>

<style>
</style>